import { connect } from 'formik';
import PropTypes from 'prop-types';
import { Component } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import {
  Text,
  Textarea,
  Checkbox,
  Select,
} from 'hb-react/shared/components/formik/components/inputs';
import { withFeatureFlag } from 'hb-react/shared/hooks/useFeatureFlag';

class Dedication extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isHidden: true,
    };
  }

  toggleDedication = () => {
    this.setState((prevState) => ({ isHidden: !prevState.isHidden }));
  };

  render() {
    const { isRequired } = this.props;
    const { isHidden } = this.state;

    return (
      <div className="grid">
        <div className="grid__item one-whole palm--one-whole">
          <Box as="h4" mb={5} font="h4-semibold">
            {__('Dedicate donation')}
          </Box>
        </div>

        <div className="grid__item one-half palm--one-whole">
          <Checkbox
            name="donation_order[dedication]"
            label={__('Dedicate Gift')}
            onChange={this.toggleDedication}
          />
          {!isHidden && (
            <>
              <div className="grid__item one-half palm--one-whole">
                <Select
                  name="donation_order[dedication_type]"
                  validate={{
                    required: true,
                  }}
                  disabled={isHidden}
                  type="default"
                  label={__('Dedication Type')}
                  options={{
                    behalf: __('On Behalf of'),
                    memory: __('In Memory of'),
                    honor: __('In Honor of'),
                  }}
                />
              </div>
              <div className="grid__item one-half palm--one-whole">
                <Text
                  name="donation_order[dedication_title]"
                  disabled={isHidden}
                  validate={{
                    maxLength: 255,
                    required: true,
                  }}
                  label={__('Name')}
                />
              </div>
              <div className="grid__item one-whole palm--one-whole">
                <Textarea
                  name="donation_order[dedication_description]"
                  disabled={isHidden}
                  minHeight={70}
                  validate={{
                    maxLength: 500,
                    required: isRequired,
                  }}
                  label={__('Additional Information')}
                />
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

Dedication.propTypes = {
  isRequired: PropTypes.bool.isRequired,
};

export default connect(withFeatureFlag(Dedication));
